<!-- TODO is this being used anywhere -->

<template>
  <b-alert
    :show="showDismissibleAlert"
    :variant="infoType"
    :class="{mini: size === 'mini'}"
    dismissible
    @dismissed="dismissAndSave">
    <slot/>
    <template
      slot="dismiss">
      <icon name="times"/>
    </template>
  </b-alert>
</template>

<script>
export default {
  name: 'InfoBox',
  props: {
    infoName: {
      type: String,
      default: '',
    },
    infoType: {
      type: String,
      default: 'success',
    },
    size: {
      type: String,
      default: '',
    },
    // text: {
    //   type: String,
    //   default: '',
    // },
  },
  computed: {
    cookieKey() {
      return `${this.infoName}-shown`;
    },
    showDismissibleAlert() {
      return !this.$cookies.isKey(this.cookieKey);
    },
  },
  methods: {
    dismissAndSave() {
      this.$cookies.set(this.cookieKey, true, '5y');
    },
  },
};
</script>
